import { render, staticRenderFns } from "./CfsiPicturePreview.vue?vue&type=template&id=b4e68b9c&"
import script from "./CfsiPicturePreview.vue?vue&type=script&lang=js&"
export * from "./CfsiPicturePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports